// extracted by mini-css-extract-plugin
export var btn = "J_mB r_r1 r_rP d_bz d_bP d_bD d_dw";
export var full = "J_vN d_w d_H";
export var hoverStyle = "J_mF";
export var zoom = "J_mG";